export var BillStatus;
(function (BillStatus) {
    BillStatus["Open"] = "OPEN";
    BillStatus["Finalized"] = "FINALIZED";
})(BillStatus || (BillStatus = {}));
//# sourceMappingURL=bill-status.enum.js.map